import {
    START_LOADING,
    END_LOADING,
    FETCH_PROPERTIES,
    FETCH_PROPERTY,
    UPDATE_PROPERTY,
    CREATE_PROPERTY,
    DELETE_PROPERTY,
    ERROR_PROPERTY,
    UPLOAD_ATTACHMENTS,
    ERROR_UPLOADING_ATTACHMENTS,
    DELETE_ATTACHMENT,
    UPLOAD_MULTIPLE_ATTACHMENTS,
    ERROR_DELETEING_ATTACHMENT
} from "../actions/constants";

const initialState = {
    isLoading: false,
    error: null,
    properties: [],
    property: null,
    attachments: [],
};

const property = (state = initialState, action) => {
    switch (action.type) {
        case START_LOADING:
            return { ...state, isLoading: true, error: null };
        case END_LOADING:
            return { ...state, isLoading: false };
        case FETCH_PROPERTIES:
            return {
                ...state,
                properties: Array.isArray(action.payload.data) ? action.payload.data : 
                           (action.payload.data && Array.isArray(action.payload.data.data)) ? action.payload.data.data : 
                           Array.isArray(action.payload) ? action.payload : [],
                currentPage: action.payload.currentPage || 1,
                numberOfPages: action.payload.numberOfPages || 1,
                error: null
            };
        case FETCH_PROPERTY:
            return { 
                ...state, 
                property: action.payload,
                error: null
            };
        case CREATE_PROPERTY:
            return {
                ...state,
                properties: [...state.properties, action.payload],
                error: null
            };
        case UPDATE_PROPERTY:
            return {
                ...state,
                properties: state.properties.map((property) =>
                    property._id === action.payload._id ? action.payload : property
                ),
                property: state.property && state.property._id === action.payload._id
                    ? action.payload
                    : state.property,
                error: null
            };
        case DELETE_PROPERTY:
            return {
                ...state,
                properties: state.properties.filter(
                    (property) => property._id !== action.payload
                ),
                error: null
            };
        case ERROR_PROPERTY:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        case UPLOAD_ATTACHMENTS:
            return {
                ...state,
                attachments: [...state.attachments, action.payload],
                error: null
            };
        case UPLOAD_MULTIPLE_ATTACHMENTS:
            return {
                ...state,
                attachments: [...state.attachments, ...(Array.isArray(action.payload) ? action.payload : [action.payload])],
                error: null
            };
        case DELETE_ATTACHMENT:
            return {
                ...state,
                attachments: state.attachments.filter(
                    (attachment) => attachment._id !== action.payload
                ),
                property: state.property ? {
                    ...state.property,
                    attachments: state.property.attachments ? 
                        state.property.attachments.filter(att => att._id !== action.payload) : 
                        []
                } : null,
                error: null
            };
        case ERROR_UPLOADING_ATTACHMENTS:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        case ERROR_DELETEING_ATTACHMENT:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            };
        default:
            return state;
    }
};

export default property;